import {RestService} from "@/services/rest/RestService";
import {NotificationTemplateAPIApi} from "@/api/pharma-master-notification-template";
import {
    NotificationTemplateRestDto,
    NotificationTemplateResultsRestDto
} from "@/api/pharma-master-notification-template/models";
import {AxiosResponse} from "axios";
import {CacheKeyEnum} from "@/services/cache/CacheKeyEnum";
import {CustomerContext} from "@/context/CustomerContext";
import {CacheService} from "@/services/cache/CacheService";

export class NotificationTemplateRestService extends RestService {

    private apiService: NotificationTemplateAPIApi;

    protected constructor() {
        super();

        this.apiService = new NotificationTemplateAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().masterUrl);
    }

    public async findNotificationTemplates(moduleCode: string): Promise<NotificationTemplateResultsRestDto> {
        const nonNullCustomerCode = CustomerContext.getCustomerCode();
        const cacheKey = this.getCacheKey(moduleCode);
        let promise: Promise<AxiosResponse<NotificationTemplateResultsRestDto>> =
            CacheService.getInstance().get(cacheKey, nonNullCustomerCode);

        if (promise !== null) {
            const result: AxiosResponse<NotificationTemplateResultsRestDto> = await promise;
            return result.data;
        }

        promise = this.apiService.getNotificationTemplates(moduleCode);

        CacheService.getInstance().set(cacheKey, promise, nonNullCustomerCode);

        const result: AxiosResponse<NotificationTemplateResultsRestDto> = await promise;
        return result.data;
    }

    public async updateNotificationTemplate(id: string, body: NotificationTemplateRestDto, moduleCode: string): Promise<void> {
        if (body.subject === '') {
            body.subject = null;
        }
        await this.apiService.updateNotificationTemplate(body, moduleCode, id);
        CacheService.getInstance().invalidate(this.getCacheKey(moduleCode), CustomerContext.getCustomerCode());
    }

    private getCacheKey(moduleCode: string): string {
        return `${CacheKeyEnum.NOTIFICATION_TEMPLATES}-${moduleCode}`;
    }
}
